import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const glTypesAdapter = getAdapter({ idFieldName: 'value' });

const glTypesSlice = createSlice({
  name: 'glTypes',
  initialState: glTypesAdapter.getInitialState(),
  reducers: {
    setGlTypes: (state, { payload: { glTypes } }) => {
      glTypesAdapter.setAll(state, glTypes);
    }
  }
});

const selectors = glTypesAdapter.getSelectors(({ glTypes }) => glTypes);

export const getGlTypes = state => selectors.selectAll(state);

export const { setGlTypes } = glTypesSlice.actions;

export default glTypesSlice.reducer;
